import {ViewHook} from 'phoenix_live_view';

type RowState = {top:number; left:number; rank:string|undefined};

// LiveView owns the rows and score text. This hook animates only their presentation.
export class RankMotion extends ViewHook {
  private previous = new Map<string, RowState>();
  private motions = new Set<Animation>();
  private preference = matchMedia('(prefers-reduced-motion: reduce)');
  private stop = () => {
    for (const animation of this.motions) animation.cancel();
    this.motions.clear();
  };
  private preferenceChanged = () => { if (this.preference.matches) this.stop(); };

  mounted() {
    this.preference.addEventListener('change', this.preferenceChanged);
  }

  beforeUpdate() {
    this.previous.clear();
    for (const row of this.el.querySelectorAll<HTMLElement>('[data-player-id]')) {
      const bounds = row.getBoundingClientRect();
      this.previous.set(row.id, {top:bounds.top, left:bounds.left, rank:row.dataset.rank});
    }
    // Capture the current animated position before replacing an in-flight transition.
    this.stop();
  }

  updated() {
    if (this.preference.matches) return;
    for (const row of this.el.querySelectorAll<HTMLElement>('[data-player-id]')) {
      const old = this.previous.get(row.id);
      const bounds = row.getBoundingClientRect();
      if (old && old.rank !== row.dataset.rank) {
        const x = old.left - bounds.left;
        const y = old.top - bounds.top;
        if (Math.abs(x) > 0.5 || Math.abs(y) > 0.5) {
          this.play(row, [
            {transform:`translate(${x}px, ${y}px)`, zIndex:2},
            {transform:'translate(0, 0)', zIndex:2}
          ], 650);
        }
      }
    }
  }

  private play(element:HTMLElement, frames:Keyframe[], duration:number) {
    const animation = element.animate(frames, {duration, easing:'cubic-bezier(.22, 1, .36, 1)'});
    this.motions.add(animation);
    animation.finished.then(()=>this.motions.delete(animation)).catch(()=>this.motions.delete(animation));
  }

  disconnected() { this.stop(); }
  destroyed() {
    this.stop();
    this.preference.removeEventListener('change', this.preferenceChanged);
  }
}
